import { render, staticRenderFns } from "./HomePageES.vue?vue&type=template&id=3fa8a058&scoped=true"
import script from "./HomePageES.vue?vue&type=script&lang=js"
export * from "./HomePageES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8a058",
  null
  
)

export default component.exports